<template>
  <LayoutDataset>
    <template v-slot:breadcrumbs>
      <div class="list-header">
        <h1>{{ $t("datasets") }}</h1>
        <Breadcrumbs :links="breadcrumbs" />
        <Search />
      </div>
    </template>
    <template v-slot:sidebar>
      <SideMenu :categories="categories" />
    </template>

    <MobileSeparator />

    <Items :items="filteredItems" :swaggerObject="swaggerObject" />
  </LayoutDataset>
</template>

<script>
import { mapState } from "vuex";
import Fuse from "fuse.js";
import SwaggerObject from "@/helpers/SwarggerObject";
import { filterData } from "@/lib/helpers";
import Search from "@/components/datasets/search";
import SideMenu from "@/components/datasets/side-menu";
import Items from "@/components/datasets/items";
import Breadcrumbs from "@/components/shared/Breadcrumbs";
import { orgConfig } from "@/mixins";
import { getMeta } from "@/helpers/MetaHelper";

import { swaggerUrl } from "@/mixins";

export default {
  mixins: [swaggerUrl, orgConfig],
  components: {
    Search,
    SideMenu,
    Items,
    Breadcrumbs
  },
  metaInfo() {
    return getMeta(
      this,
      this.$t("datasets_title", {
        dataset: this.swaggerObject ? this.swaggerObject.summary : ""
      }),
      this.$t("datasets_description")
    );
  },
  data: function() {
    return {
      items: [],
      swaggerObject: null
    };
  },
  computed: {
    ...mapState("datasets", ["currentCategory", "query"]),

    breadcrumbs() {
      return [
        {
          name: "datasets",
          link: "datasets"
        }
      ];
    },
    filteredItems() {
      let items = this.items;

      if (this.currentCategory) {
        items = items.filter(item => item.tags.includes(this.currentCategory));
      }

      if (this.query) {
        const options = {
          keys: ["summary", "description"]
        };

        return new Fuse(items, options).search(this.query);
      }
      return items;
    },
    categories() {
      const categories = this.items.map(row => {
        return row.tags;
      });

      let counts = {};

      categories.forEach(el => {
        counts[el] = (counts[el] || 0) + 1;
      });

      return Object.entries(counts).map(row => ({
        name: row[0],
        count: row[1]
      }));
    }
  },
  mounted() {
    if (window.__PRERENDER_INJECTED) {
      this.items = [];
      this.swaggerObject = {};
      return;
    }

    const swagger = new SwaggerObject();

    swagger
      .init(this.swaggerUrl())
      .then(() => {
        this.swaggerObject = swagger;
        this.items = filterData(this.swaggerObject.datasets);
      })
      .catch(() => {
        this.$message({
          type: "error",
          message: this.$t("common.flashMessages.somethingWentWrong")
        });
      });
  },
  destroyed() {
    this.$store.dispatch("datasets/resetState");
  }
};
</script>

<style lang="scss" scoped>
.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h1 {
  margin: rem(-13) 0 rem(10);
  width: 100%;
  font-size: rem(20);
  display: none;
  color: $--color-text-dark;
  @include media("<navbar-sm") {
    display: block;
  }
}
</style>
